import React from "react";
import Pagination from "../../components/common/Pagination";
import ItemPerPage from "../../components/common/ItemPerPage";
import FilterBox from "../../components/common/FilterBox";
import { TableWarpper, TabsDetailsWrapper, Text, ButtonSolid } from "../../components/styledConstants";
import { isEmpty } from "../../utils/common";
import TableLoader from "../common/TableLoader";
import { FilterWrapper } from "../../Pages/Merchants/style";

export default function ({
  filterForm,
  onFilterChange,
  onFilterSubmit,
  setCurrentPage,
  paymentLists,
  paginationData,
  page,
  loading = false,
  refreshPage,
  setPageSize,
  validateTransaction,
}) {
  return (
    <>
      <div className="flex flex-center space-between " style={{marginTop:"-10px"}}></div>
      {/* <FilterWrapper>
          {page !== "dashboard" && (
            <FilterBox
              filterForm={filterForm}
              onFilterChange={onFilterChange}
              onFilterSubmit={onFilterSubmit}
              className="transactionfilter"
              refreshPage={refreshPage}
              
            />
          )}
        </FilterWrapper> */}
      <TabsDetailsWrapper className="pd-bottom">
        {loading ? (
          <div className="table-loader-wrapper animatedBackground"></div>
        ) : (
          <TableWarpper className="mt24">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Source User Id
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Name
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Mobile Number
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Narration
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Transaction ID
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Reference Transaction Id
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Transaction Type
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Payment Mode
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                    CARD REFERENCE NUMBER

                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                    CHANNEL MODE

                    </Text>
                  </th>

                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Status
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      RESPONCE CODE
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      RESPONSE DISCRIPTION
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      MCC CODE
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Transaction Date
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Amount
                    </Text>
                  </th>

                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Service Charges
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Commission
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      GST as per 18%
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Opening Balance
                    </Text>
                  </th>

                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Closing Balance
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Final Amount
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Buying Cost
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Mufin Profit/(Loss)
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Distributor Charge
                    </Text>
                  </th>
                  {/* <th className="text-left">
                    <Text size="rg" fw="medium">
                      Agent Fee
                    </Text>
                  </th> */}

                  {/*  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Total ServiceFee
                    </Text>
                  </th>*/}
                  {/* <th className="text-left">
                    <Text size="rg" fw="medium">
                      Agent UUID
                    </Text>
                  </th> */}
                  {/* <th className="text-left">
                    <Text size="rg" fw="medium">
                      Agent Name
                    </Text>
                  </th> */}
                  {/* <th className="text-left">
                    <Text size="rg" fw="medium">
                      Distributor UUID
                    </Text>
                  </th> */}
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Distributor Name
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      IP Address
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      SETTLEMENT STATUS
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      SETTLEMENT DATE
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      RISK CATEGORY
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                     RRN
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      FAILED REASON
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Wallet Type
                    </Text>
                  </th>
                  <th className="text-left">
                    <Text size="rg" fw="medium">
                      Remarks
                    </Text>
                  </th>
                  {/* <th className="text-left">
                    <Text size="rg" fw="medium">
                      Action
                    </Text>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {paymentLists.length ? (
                  paymentLists.map((payment, index) => (
                    <tr key={index}>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.sourceUserId}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.sourceUserName}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.sourceMobileNumber}
                        </Text>
                      </td>
                      {payment.transationType ==="DEBIT" ?
                       <td>
                        <Text size="xsm" color="color3">
                       Debit to  {payment.destinationUserName}
                        </Text>
                      </td> :  <td>
                        <Text size="xsm" color="color3">
                       Credit from  {payment.destinationUserName}
                        </Text>
                      </td> }
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.transactionId}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.refTransactionId}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.transationType}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.transactionMode}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment. cardRefNumber}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.channelMode}
                        </Text>
                      </td>
                      <td>
                        <Text
                          size="xsm"
                          color={
                            payment.txnStatus === "DONE"
                              ? "color10"
                              : payment.txnStatus === "FAILED"
                              ? "color11"
                              : "colo4"
                          }
                        >
                          {payment.txnStatus}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment?.channelMode}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment?.channelMode}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment?.mcc}
                        </Text>
                      </td>
                      
                      
                      <td>
                        <Text size="xsm" color="color3">
                          {payment.transactionDate ? payment.transactionDate.split("T")[0]+" "+ payment.transactionDate?.split("T")[1]?.split(".")?.[0] : ""}
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.baseAmount != null ? "₹" : null} </span> &nbsp;
                          <span>{payment.baseAmount != null ? payment.baseAmount.toFixed(2) : "₹ 0"} </span>
                        </Text>
                      </td>

                      <td className="nowrap">
                        <Text size="xsm" color="color3" fw="medium">
                          <span>{payment.totalServiceFee != null ? "₹" : null} </span> &nbsp;
                          <span>{payment.totalServiceFee != null ? payment.totalServiceFee.toFixed(2) : "₹ 0"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color3" fw="medium">
                          <span>{payment.commission != null ? "₹" : null} </span> &nbsp;
                          <span>{payment.commission != null ? payment.commission.toFixed(2) : "₹ 0"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color3" fw="medium">
                          <span>{payment.gstAmount != null ? "₹" : null} </span> &nbsp;
                          <span>{payment.gstAmount != null ? payment.gstAmount.toFixed(2) : "₹ 0"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.openingBalance != null ? "₹" : null} </span> &nbsp;
                          <span>{payment.openingBalance != null ? payment.openingBalance.toFixed(2) : "₹ 0"} </span>
                        </Text>
                      </td>

                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.closignBalance != null ? "₹" : null} </span> &nbsp;
                          <span>{payment.closignBalance != null ? payment.closignBalance.toFixed(2) : "₹ 0"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{`Rs. ${parseFloat(payment?.finalAmount || "0").toFixed(2)}`}</span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.buyingCost} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.mufinFee} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.distributorFee} </span>
                        </Text>
                      </td>
                      {/* <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.agentFee} </span>
                        </Text>
                      </td> */}

                      {/* <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.totalServiceFee || "NA"} </span>
                        </Text>
                      </td>*/}
                      {/* <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.agentId || "NA"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.agentName || "NA"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.distributorId || "NA"} </span>
                        </Text>
                      </td> */}
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment.distributorName || "NA"} </span>
                        </Text>
                      </td>
                      <td className="nowrap">
                        <Text size="xsm" color="color1" fw="medium">
                          <span>{payment?.ipAddress || "NA"} </span>
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment?.settlementStatus}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color3">
                          {payment?.settlementDate}
                        </Text>
                      </td>
                      <td>
                        <Text size="xsm" color="color1" fw="medium">
                          {payment?.riskCategory || "-"}
                        </Text>
                      </td>
                          <td>
                     <Text size="xsm" color="color1" fw="medium">
                  {payment?.rrn || "NA"}
                     </Text>
                    </td>
                      <td>
                     <Text size="xsm" color="color1" fw="medium">
                  {payment?.failedReason?.trim() ? payment.failedReason : "NA"}
                     </Text>
                    </td>
                    <td>
                       <Text size="xsm" color="color1" fw="medium">
                       {payment?.walletType?.trim() ? payment.walletType : "NA"}
                       </Text>
                      </td>
                      <td>
                       <Text size="xsm" color="color1" fw="medium">
                       {payment?.remark?.trim() ? payment.remark : "NA"}
                       </Text>
                      </td>

                      {/* <td className="nowrap">
                        <ButtonSolid
                          className="btn-download flex flex-center justify-center"
                          primary
                          xl
                          onClick={() => {
                            validateTransaction(payment.transactionId, payment.transactionMode);
                          }}
                        >
                          Check Status
                        </ButtonSolid>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={11} style={{ textAlign: "center", lineHeight: "30px" }}>
                      No record found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </TableWarpper>
        )}
      </TabsDetailsWrapper>
      <div className="mt24 flex flex-center">
        {paymentLists.length > 1 && (
          <ItemPerPage
            pageSize={paginationData.pageSize}
            getPageSize={(pageSize) => {
              setPageSize(pageSize);
            }}
          />
        )}
        {paginationData.totalPages > 1 && (
          <Pagination
            totalPages={paginationData.totalPages}
            currentPage={paginationData.currentPage}
            getCurrentPageData={(curpage) => {
              setCurrentPage(curpage);
            }}
          />
        )}
      </div>
    </>
  );
}
